<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
        'branch': Object,
    },
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();

            if (vm.branch.id)
                vm.data.branch_id = vm.branch.id;
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                store_id: null,
                branch_id: null,
                date: vm.$dateFormat.iso(new Date),
                open_at: vm.$dateFormat.dTime(),
                closed_at: vm.$dateFormat.dTime(),
                notes: null
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            vm.$loading.on('branch_detail_special_day_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.SpecialDay.create(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('branch_detail_special_day_submit');
        },
        _createPostData: function (data) {
            return data;
        },
        fetchBranch: async function (params) {
            const resp = await this.$api.Branch.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12" v-if="$ac.hasAccess('special_day_full_access')">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.branch')
                            }}</label>
                        <dynamic-select v-model="data.branch_id" :placeholder="$t('special_day.placeholder.branch')"
                            :loadOptions="fetchBranch" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.date') }}</label>
                        <datepicker v-model="data.date" />
                    </BCol>
                    <BCol lg="6">
                        <label class="form-label" for="product-title-input">{{
                            $t('special_day.label.open_at')
                            }}</label>
                        <timepicker v-model="data.open_at" />
                    </BCol>
                    <BCol lg="6">
                        <label class="form-label" for="product-title-input">{{
                            $t('special_day.label.closed_at') }}</label>
                        <timepicker v-model="data.closed_at" />
                    </BCol>
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('special_day.label.notes')
                            }}</label>
                        <textarea class="form-control" id="exampleFormControlTextarea5" rows="5" v-model="data.notes"
                            :placeholder="$t('special_day.placeholder.notes')"></textarea>
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('special_day_full_access') || ($ac.hasAccess('special_day_create') && $ac.hasAccessStore(branch.store_id)))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="success" class="w-100" @click="submit"
                                    :disabled="$loading.get('branch_detail_special_day_submit')">
                                    <loading :loading="$loading.get('branch_detail_special_day_submit')" variant="light"
                                        type="button">
                                        <i class="mdi mdi-floppy me-1"></i>
                                        {{ $t('basic.btn.save') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>